// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__sW54D","verticalCentring":"styles_verticalCentring__O0yYl","logoutCol":"styles_logoutCol__1T4cB"};